<template>
    <div class="kgk-password-forgotten">
        <h2 v-if="!insideModal">
            Passwort vergessen
        </h2>
        <form @submit.prevent="requestReset">
            <div class="kgk-form-row">
                E-Mail-Adresse
                <div class="kgk-input-group">
                    <input type="email" v-model="form.email">
                </div>
            </div>
            <div v-if="!insideModal" class="kgk-form-row">
                <button type="submit">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span class="button-text">Passwort zurücksetzen</span>
                </button>
            </div>
            <p>
                Gib hier deine E-Mail-Adresse an, mit welcher du deinen Account erstellt hast. Wir schicken dir dann eine E-Mail mit einem Link zum Zurücksetzen deines Passworts.
            </p>
        </form>

        <!--
        <div class="spacer"></div>
        <h2>Ich habe den Code aus der E-Mail bereits</h2>
        <form @submit.prevent="resetCodeGiven">
            <div class="kgk-form-row">
                Code
                <div class="kgk-input-group">
                    <input type="text" v-model="resetCode">
                </div>
            </div>
            <div class="kgk-form-row">
                <button type="submit">
                    Passwort zurücksetzen
                </button>
            </div>
        </form>
        -->
    </div>
</template>

<script>
    import registration from '../../api/registration';
    import router from '../../router';

    export default {
        name: 'PasswordForgottenForm',
        components: {

        },
        props: {
            insideModal: {
                type: Boolean,
                required: true,
                default: false,
            },
            modalSaveTrigger: {
                type: Object,
                required: false
            },
        },
        data() {
            return {
                loading: false,
                form: {
                    email: '',
                },
                resetCode: '',
                error: '',
            }
        },
        computed: {
            emailRequiredValidation() {
                const lengthTrimmed = this.form.email.trim();

                return lengthTrimmed.length > 0;
            },
        },
        methods: {
            requestReset(/*calledFromModal*/) {
                //calledFromModal = calledFromModal || false;

                if( this.loading ) {
                    return;
                }

                if( !this.emailRequiredValidation ) {
                    this.$notify({
                        type: 'warn',
                        title: 'Eingaben fehlerhaft.',
                        text: 'Bitte gib deine E-Mail-Adresse an.'
                    });

                    return;
                }

                this.loading = true;

                //if( calledFromModal ) {
                this.$emit('loadingStarted');
                //}

                registration.requestPasswordReset(
                    this,
                    this.form.email,
                    () => {
                        this.$notify({
                            type: 'success',
                            title: 'Passwort zurücksetzen',
                            text: `Wenn ein Account unter dieser E-Mail-Adresse existiert, wurde ein "Passwort zurücksetzen"-Link an diese Adresse geschickt, mit dem du dein Passwort neu setzen kannst.`
                        });

                        this.$emit('requested');
                    },
                    e => {
                        //console.error(e.response.status);
                        if( e.response.status == 400 ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => {
                        this.loading = false;
                        //if( calledFromModal ) {
                        this.$emit('loadingEnded');
                        //}
                    }
                );

                return true;
            },

            resetCodeGiven() {
                const code = this.resetCode.trim();
                if( code.length < 1 ) {
                    return;
                }

                this.$modal.hide('dialog');
                router.push('/password-reset/' + encodeURIComponent(code));
            },

        },
        watch: {
            'modalSaveTrigger.trigger'() {
                this.requestReset();
            },
        },
        mounted() {

        }
    }
</script>

